module.exports = __webpack_public_path__ + "static/IftttWH-2e196692a0e80370a3dba7223c7289ba.png";